module.exports = __webpack_public_path__ + "img/1545437565.c4a6955a.jpg";